import { featuresData } from '@/mocks/homeData';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-3xl font-heading text-foreground-950 text-center mb-10">
          平台特色
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {featuresData.map((item, i) => (
            <div
              key={i}
              className="bg-background-100 rounded-lg border border-background-200/70 p-6 flex flex-col items-center text-center gap-3 transition-all duration-300 hover:-translate-y-1"
            >
              <div className="w-14 h-14 rounded-xl bg-accent-100 flex items-center justify-center">
                <i className={`${item.icon} text-accent-600 text-2xl`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-950">{item.title}</h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}